import React from 'react';
import PropTypes from 'prop-types';


require("../../../../less/Testimonial.less");
const Testimonial = (props) => {
  const {
    testimonialImage, testimonialTitle,
    testimonialDescription, titleIntro, linkAble, link
  } = props;
  return (
    <div className="testimonial-container">
      <div className="image-border">
        <img src={testimonialImage} className="testimonial-image" alt="testimonialImage" />
      </div>
      <h3 className="testimonial-title">{testimonialTitle}</h3>
      {linkAble ? (<a className="title-tip" href={link}>{titleIntro}</a>) : (<p className="title-tip">{titleIntro}</p>)}
      <p className="testimonial-description">{testimonialDescription}</p>
    </div>
  ) 
}

Testimonial.propTypes = {
  testimonialImage: PropTypes.string.isRequired,
  testimonialTitle: PropTypes.string.isRequired,
  testimonialDescription: PropTypes.string.isRequired,
  titleIntro: PropTypes.string.isRequired,
  linkAble: PropTypes.bool,
  link: PropTypes.string
};
// Testimonial.defaultProps = {
//   linkAble: false,
//   link="/"
// }
module.exports = Testimonial;


// WEBPACK FOOTER //
// ./src/js/components/Pages/Testimonial/Testimonial.js